<div class=" row mt-3 " style="padding: 10px;">
                         
                          
    <div class="col-md-12 " >
      <div class="row col-md-12">
        <label class="col-md-4" for="iata" style="text-align: left;">IATA Commission	</label>
        <div class="col-md-4"></div>
        <div class="col-md-4"></div>
        <div class="col-md-4">
        <input  type="file"  class="form-control" accept=".xlsx, .xls" (change)="onFileSelected($event)" #fileInput type="file"  >
        </div>
        <div class="col-md-4">
            <button mat-flat-button  style="min-width: 100%;  color: white; background-color: #007bff; margin-left: 8px;font-weight: bold;" (click)="uploadFile()">Upload Iata Details [Excel] </button>

        </div>
        <div class="col-md-4">
            <button mat-flat-button  style="min-width: 100%; color: white; background-color: #007bff; margin-left: 8px;font-weight: bold;"   >Download Details [Excel]</button>

        </div>
        <div class="col-md-12 mt-2">
            <mat-divider></mat-divider>

        </div>

        <mat-form-field class="col-md-4 mt-2" appearance="outline">
            <mat-label>Carrier</mat-label>
            <mat-select matNativeControl name="carrier" [(ngModel)]="carrierCode">
              <mat-option *ngFor="let item of carrierCodeList"  [value]='item.airlineDesignatorCode'>{{item.carrierName}}</mat-option>

            </mat-select>  
          </mat-form-field>  
      <div class="col-md-4"></div>
      <div class="col-md-4 mt-2">
        <button mat-flat-button  style="min-width: 100%; height: 55px; color: white; background-color: #007bff; margin-left: 8px;font-weight: bold;"  (click)="commissionList()" [disabled]="!carrierCode" >Search By Carrier </button>

      </div>

      
      </div>
      <div class="col-md-12 card">
      <table mat-table
      [dataSource]="iataCommissionData" multiTemplateDataRows style="background-color: transparent;">
     
      <!-- <ng-container matColumnDef="expand">
        <th  mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
        <td mat-cell *matCellDef="let element">
        <button mat-icon-button aria-label="expand row" (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
          <mat-icon *ngIf="expandedElement !== element">arrow_right</mat-icon>
          <mat-icon *ngIf="expandedElement === element">arrow_drop_down</mat-icon>
        </button>
        </td>
        </ng-container> -->
       <ng-container matColumnDef="iataCode">
         <th mat-header-cell *matHeaderCellDef>Iata Code</th>
         <td mat-cell *matCellDef="let element" style="height: 40px;" > {{element?.iataCode}} </td>
         
         
       </ng-container>
      <ng-container matColumnDef="carrierName">
       <th mat-header-cell *matHeaderCellDef> Carrier Name </th>
       <td mat-cell *matCellDef="let element"> 
       {{element?.carrierName}}</td>
      </ng-container>
      
     
      <ng-container matColumnDef="sTax">
        <th mat-header-cell *matHeaderCellDef>sTax on YQ</th>
        <td mat-cell *matCellDef="let element"> <input style="height:15px;width:15px;cursor: pointer;" [(ngModel)]="element.staxOnYQ" type="checkbox"></td>
       </ng-container>
       <ng-container matColumnDef="ClubYQ">
        <th mat-header-cell *matHeaderCellDef>Club YQ with Base</th>
        <td mat-cell *matCellDef="let element"> <input style="height:15px;width:15px;cursor: pointer;" [(ngModel)]="element.clubYQWithBase" type="checkbox"></td>
       </ng-container>
       <ng-container matColumnDef="ClubOC">
        <th mat-header-cell *matHeaderCellDef>Club OC with Base</th>
        <td mat-cell *matCellDef="let element"> <input style="height:15px;width:15px;cursor: pointer;" [(ngModel)]="element.clubOCWithBase" type="checkbox"></td>
       </ng-container>
       <ng-container matColumnDef="ClubCongestion">
        <th mat-header-cell *matHeaderCellDef>Club Congestion Charge with Base</th>
        <td mat-cell *matCellDef="let element"> <input style="height:15px;width:15px;cursor: pointer;" [(ngModel)]="element.clubCongestionChargesWithBase" type="checkbox"></td>
       </ng-container>
       <ng-container matColumnDef="Commission">
        <th mat-header-cell *matHeaderCellDef>Commission on Private Fare</th>
        <td mat-cell *matCellDef="let element"> <input style="height:15px;width:15px;cursor: pointer;" [(ngModel)]="element.privateFareCommissionable" type="checkbox"></td>
       </ng-container>
     

      
     
      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsDisplay.length">
      <div class="example-element-detail row"
       [@detailExpand]="element == expandedElement ? 'expanded' : ''">
      <div class="col-md-12  row"> 
        <mat-form-field class="col-md-3 mt-2"  appearance="outline">
            <mat-label>In Domestic %</mat-label>
            <input matInput type="text" [(ngModel)]="element.domesticPercentile"  (keypress)="onlyNumberKey($event)" name="inDomestic" autocomplete="off" >
        </mat-form-field>  
        <mat-form-field class="col-md-3 mt-2"  appearance="outline">
            <mat-label>In International %</mat-label>
            <input matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="element.internationalPercentile" name="int" autocomplete="off" >
        </mat-form-field> 
        <mat-form-field class="col-md-3 mt-2"  appearance="outline">
            <mat-label>In SOTO %</mat-label>
            <input matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="element.sotoPercentile" name="soto" autocomplete="off" >
        </mat-form-field> 
        <mat-form-field class="col-md-3 mt-2"  appearance="outline">
            <mat-label>Out Domestic %</mat-label>
            <input matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="element.outDomesticPercentile" name="outDom" autocomplete="off" >
        </mat-form-field> 
        <mat-form-field class="col-md-3 mt-2"  appearance="outline">
            <mat-label>Out International %</mat-label>
            <input matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="element.outInternationalPercentile" name="outInt" autocomplete="off" >
        </mat-form-field> 
        <mat-form-field class="col-md-3 mt-2"  appearance="outline">
            <mat-label>Out SOTO %</mat-label>
            <input matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="element.outSotoPercentile" name="outSoto" autocomplete="off" >
        </mat-form-field> 
        <mat-form-field class="col-md-3 mt-2"  appearance="outline">
            <mat-label>OC Rate %</mat-label>
            <input matInput type="text" (keypress)="onlyNumberKey($event)" [(ngModel)]="element.ocCharge" name="oc" autocomplete="off" >
        </mat-form-field> 
        <div class="col-md-3 mt-2">
            <button mat-flat-button  style="min-width: 100%; height: 55px; color: white; background-color: #007bff; margin-left: 8px;font-weight: bold;" (click)="updateCommission(element)"   >UPDATE</button>
    
          </div>
      </div>

      </div>
      </td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="columnsDisplay"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsDisplay;"
      class="example-element-row">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
      <tr class="mat-row" *matNoDataRow>
      <td  class="mat-cell" colspan="4">There is no data in this table</td>
      </tr>
      </table>
    </div>
      
      
      </div>
      
  

</div> 